import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { AppSettings } from "../../proyect.conf";
import { ProductoRestriccionSubdestino } from "../_models/producto-restriccion-subdestino";
import { AutenticacionService } from "./autenticacion.service";

@Injectable({
  providedIn: "root",
})
export class ProductoRestriccionSubdestinoService {
  private rutServicio =
    AppSettings.rutServiciosAPL + "/api/productosRestriccionesSubdestinos";

  constructor(
    private httClient: HttpClient,
    private authServicio: AutenticacionService
  ) {}

  listado() {
    return this.httClient
      .get(this.rutServicio)
      .pipe(map((res) => res as ProductoRestriccionSubdestino[]));
  }

  listadoHabilitados() {
    return this.httClient
      .get(this.rutServicio + "/enabled")
      .pipe(map((res) => res as ProductoRestriccionSubdestino[]));
  }

  listadoPorProducto(idProducto: string) {
    return this.httClient
      .get(this.rutServicio + "/productos/" + idProducto)
      .pipe(map((res) => res as ProductoRestriccionSubdestino[]));
  }

  listadoPorEstructuraFisica(idEstructuraFisica: string) {
    return this.httClient
      .get(this.rutServicio + "/estructuraFisica/" + idEstructuraFisica)
      .pipe(map((res) => res as ProductoRestriccionSubdestino[]));
  }

  listadoPorSubdestinos(idSubdestino: string) {
    return this.httClient
      .get(this.rutServicio + "/listasSubdestinosProductos/" + idSubdestino)
      .pipe(map((res) => res as ProductoRestriccionSubdestino[]));
  }

  listadoPorDestino(idDestino: string) {
    return this.httClient
      .get(this.rutServicio + "/listasDestinosProductos/" + idDestino)
      .pipe(map((res) => res as ProductoRestriccionSubdestino[]));
  }

  listadoPorEstructuraFisicaYSubdestino(
    idEstructuraFisica: string,
    idSubdestino: string
  ) {
    return this.httClient
      .get(
        this.rutServicio +
          "/estructuraFisica/" +
          idEstructuraFisica +
          "/listasSubdestinosProductos/" +
          idSubdestino
      )
      .pipe(map((res) => res as ProductoRestriccionSubdestino[]));
  }

  listadoPorDestinoYSubdestino(idDestino: string, idSubdestino: string) {
    return this.httClient
      .get(
        this.rutServicio +
          "/listasDestinosProductos/" +
          idDestino +
          "/listasSubdestinosProductos/" +
          idSubdestino
      )
      .pipe(map((res) => res as ProductoRestriccionSubdestino[]));
  }

  listadoPorEstructuraFisicaYDestino(
    idEstructuraFisica: string,
    idDestino: string
  ) {
    return this.httClient
      .get(
        this.rutServicio +
          "/estructuraFisica/" +
          idEstructuraFisica +
          "/listasDestinosProductos/" +
          idDestino
      )
      .pipe(map((res) => res as ProductoRestriccionSubdestino[]));
  }

  listadoPorEstructuraFisicaYDestinoHabilitados(
    idEstructuraFisica: string,
    idDestino: string
  ) {
    return this.httClient
      .get(
        this.rutServicio +
          "/estructuraFisica/" +
          idEstructuraFisica +
          "/listasDestinosProductos/" +
          idDestino +
          "/enabled"
      )
      .pipe(map((res) => res as ProductoRestriccionSubdestino[]));
  }

  listadoPorProductoYEstructuraFisicaYDestino(
    idProducto: string,
    idEstructuraFisica: string,
    idDestinoProducto: string
  ) {
    return this.httClient
      .get(
        this.rutServicio +
          "/productos/" +
          idProducto +
          "/estructuraFisica/" +
          idEstructuraFisica +
          "/listasDestinosProductos/" +
          idDestinoProducto
      )
      .pipe(map((res) => res as ProductoRestriccionSubdestino[]));
  }

  listadoPorProductoYEstructuraFisicaYDestinoHabilitados(
    idProducto: string,
    idEstructuraFisica: string,
    idDestinoProducto: string
  ) {
    return this.httClient
      .get(
        this.rutServicio +
          "/productos/" +
          idProducto +
          "/estructuraFisica/" +
          idEstructuraFisica +
          "/listasDestinosProductos/" +
          idDestinoProducto +
          "/enabled"
      )
      .pipe(map((res) => res as ProductoRestriccionSubdestino[]));
  }

  listadoPorProductoYEstructuraFisicaYDestinoYSubdestino(
    idProducto: string,
    idEstructuraFisica: string,
    idDestino: string,
    idSubdestino: string
  ) {
    return this.httClient
      .get(
        this.rutServicio +
          "/unica/productos/" +
          idProducto +
          "/estructuraFisica/" +
          idEstructuraFisica +
          "/listasDestinosProductos/" +
          idDestino +
          "/listasSubdestinosProductos/" +
          idSubdestino
      )
      .pipe(map((res) => res as ProductoRestriccionSubdestino));
  }

  obtenerPorId(id: string) {
    return this.httClient
      .get(this.rutServicio + "/" + id)
      .pipe(map((res) => res as ProductoRestriccionSubdestino));
  }

  crear(regCrear: ProductoRestriccionSubdestino) {
    regCrear.auditoriaUsuario = this.authServicio.obtenerIdUsuarioLogueado();
    return this.httClient
      .post(this.rutServicio, regCrear)
      .pipe(map((res) => res as ProductoRestriccionSubdestino));
  }

  actualizar(regActualizar: ProductoRestriccionSubdestino) {
    regActualizar.auditoriaUsuario =
      this.authServicio.obtenerIdUsuarioLogueado();
    return this.httClient
      .put(this.rutServicio, regActualizar)
      .pipe(map((res) => res as any));
  }

  bulk(regActualizar: ProductoRestriccionSubdestino[]) {
    regActualizar.map((s: ProductoRestriccionSubdestino) => {
      s.auditoriaUsuario = this.authServicio.obtenerIdUsuarioLogueado();
    });
    return this.httClient
      .post(this.rutServicio + "/bulk", regActualizar)
      .pipe(map((res) => res as any));
  }
}
